/**
 * Sidebar Icon
 *
 */

import React from 'react'

export default function inspiration(props = {}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 2.25098V0.750977"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.364 4.88803L19.425 3.82703"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 11.251H22.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.364 17.615L19.425 18.676"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.63595 4.88803L4.57495 3.82703"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 11.251H1.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.63595 17.615L4.57495 18.676"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 16.449V18.749C9 19.5446 9.31607 20.3077 9.87868 20.8703C10.4413 21.4329 11.2044 21.749 12 21.749C12.7956 21.749 13.5587 21.4329 14.1213 20.8703C14.6839 20.3077 15 19.5446 15 18.749V16.449"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 17.251C15.3137 17.251 18 14.5647 18 11.251C18 7.93727 15.3137 5.25098 12 5.25098C8.68629 5.25098 6 7.93727 6 11.251C6 14.5647 8.68629 17.251 12 17.251Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 21.751V23.251"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
